import { QueryResources, _QueryResources } from '@/lib/datx-jsonapi-react';
import { ProfileInstitutions } from '@/resources/ProfileInstitutions';
import { ThinProfile } from '@/resources/ThinProfile';

export const queryProfileInstitutions = (profileId: string): QueryResources<ProfileInstitutions> => {
  if (!profileId) return null;
  return [
    `${ThinProfile.type}/${profileId}/institutions`,
    {
      params: [
        {
          key: 'page[size]',
          value: '100',
        },
      ],
    },
  ];
};

export const queryThinProfilesByUserId = (id: string): _QueryResources<ThinProfile> => {
  return id
    ? [
        ThinProfile,
        {
          filter: {
            user_id: id,
          },
        },
      ]
    : null;
};
